import React from "react";
import { FaLinkedinIn, FaGithubAlt } from "react-icons/fa";
import { BsInstagram, BsFacebook } from "react-icons/bs";

const SocialMedia = () => {
  return (
    <div className="app__social">
      <a
        href="https://www.linkedin.com/in/h-abhijit-singha-b862b3249/"
        target="_blank"
      >
        <FaLinkedinIn />
      </a>
      <a href="https://github.com/Abhijitsingha-code" target="_blank">
        <FaGithubAlt />
      </a>
      <a href="https://www.facebook.com/abhijit.hijam.1" target="_blank">
        <BsFacebook />
      </a>
      <a href="https://www.instagram.com/abhijitsingha__/" target="_blank">
        <BsInstagram />
      </a>
    </div>
  );
};

export default SocialMedia;
